import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import './radioInput.css';

export default function RadioInput(props) {
  return (
    <div>
      <FormControl>
        {props.showLabel ? (
          <div>
            <FormLabel id="radio-buttons-group">
              {props.question.questionDescr}
            </FormLabel>
          </div>
        ) : null}
        {props.validationError ? (
          <div>
            <p className="radio-input-required">
              * Required. You must select one.
            </p>
          </div>
        ) : null}
        {props.isQuestionWithAnswer ? (
          <RadioGroup
            aria-labelledby="radio-buttons-group"
            value={props.question.vetEvalAnswerListId}
            onChange={props.onChange}
          >
            <div>
              {props.question.selectionList.map((selection) => (
                <div>
                  <FormControlLabel
                    disabled={props.disabled}
                    key={selection.vetEvalAnswerListId}
                    value={selection.vetEvalAnswerListId}
                    control={<Radio />}
                    label={selection.itemDescr}
                  />
                </div>
              ))}
            </div>
          </RadioGroup>
        ) : null}
      </FormControl>
    </div>
  );
}
